import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";

export const mapToClaimReopenReason = mapDictionaryState;

const surveyClosedReasonApi = createDictionaryApiFactory("surveyClosedReason");

export const getSurveyClosedReason = surveyClosedReasonApi.search;
export const getSurveyClosedReasonDetail = surveyClosedReasonApi.getDetail;
export const exportCsvSurveyClosedReason = surveyClosedReasonApi.exportCsv;
